import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, IMAGE_URL } from "../config/config"; // Adjust path if needed

const Search = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search).get("q");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const trimmed = query?.trim() || "";

    if (trimmed.length < 3) {
      toast.warn("Search term must be at least 3 characters.");
      navigate("/shop");
      return;
    }

    const fetchSearchResults = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BASE_URL}/search_products?q=${trimmed}`
        );

        if (response.data.status) {
          setResults(response.data.data || []);
        } else {
          setResults([]);
          toast.warn(response.data.message || "No products found.");
        }
      } catch (error) {
        console.error("Search error:", error);
        toast.error("Something went wrong while searching.");
      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [query, navigate]);

    const handleRegisterClick = (course) => {
    navigate(`/course/${course.product_id}`, { state: { course } });
  };


  return (
    <section className="courses archive section"
    style={{ paddingTop: "150px" }}>
      <div className="container">
        <h4 className="mb-4 text-center">Search Results for "{query}"</h4>

        <div className="row">
          {loading ? (
            <div className="col-12 text-center py-5">Loading courses...</div>
          ) : results.length === 0 ? (
            <div className="col-12 text-center py-5">
              No matching courses found.
            </div>
          ) : (
            results.map((course) => {
              let originalPrice = 0;
              try {
                const parsed = JSON.parse(course.price);
                originalPrice = parsed[0]?.price || "0";
              } catch {
                originalPrice = "0";
              }

              return (
                <div
                  className="col-lg-4 col-md-6 col-12 mb-4"
                  key={course.product_id}
                >
                  <div className="single-course">
                    <div className="course-head overlay">
                      <img
                        src={`${IMAGE_URL}/uploads/${course.image}`}
                        alt={course.product_name}
                      />
                     <button
                      type="button"
                      onClick={() => handleRegisterClick(course)}
                      className="btn white primary"
                    >
                      Enroll Now
                    </button>
                    </div>

                    <div className="course-body">
                      <div className="name-price">
                        <span className="price">₹{originalPrice}</span>
                      </div>
                      <h4 className="c-title">
                        <Link to={`/course/${course.product_name}`}>
                          {course.product_name}
                        </Link>
                      </h4>
                      <p>
                        {course.description
                          ? course.description.slice(0, 100) + "..."
                          : "No description available."}
                      </p>
                    </div>

                    <div className="course-meta">
                      <ul className="rattings">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <li key={star}>
                            <i
                              className={
                                course.rating >= star
                                  ? "fa fa-star"
                                  : course.rating >= star - 0.5
                                  ? "fa fa-star-half-o"
                                  : "fa fa-star-o"
                              }
                            ></i>
                          </li>
                        ))}
                        <li className="point">
                          <span>{(course.rating || 4.5).toFixed(1)}</span>
                        </li>
                      </ul>
                      <div className="course-info">
                        <span>
                          <i className="fa fa-users"></i>
                          {course.enrolled || "2.4k"} Enrolled
                        </span>
                        <span>
                          <i className="fa fa-calendar-o"></i>
                          {course.duration || "2 Months"}
                        </span>
                        <span>
                          <i className="fa fa-clock-o"></i>
                          {course.timing || "09:30 - 12:00"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="d-flex justify-content-center w-100 pt-4">
          <Link to="/courses">
            <button className="text-uppercase text-white px-4 py-2 border border-dark bg-dark hover-effect">
              Back to Courses
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Search;
